export default {
  standardTasks: (state) => state.standardTasks,
};
